'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocationAwarePurchaseMotionData = exports.getPurchaseMotionData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _AuthStates = require('self-service-api/constants/AuthStates');

var _purchaseMotionApi = require('self-service-api/core/api/purchaseMotionApi');

var _validators = require('self-service-api/core/validators');

var _productsAdapter = require('self-service-api/adapters/productsAdapter');

var _productsAdapter2 = _interopRequireDefault(_productsAdapter);

var _availableTrialsAdapter = require('self-service-api/adapters/availableTrialsAdapter');

var _availableTrialsAdapter2 = _interopRequireDefault(_availableTrialsAdapter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _adaptPurchaseMotionResponse = function _adaptPurchaseMotionResponse(purchaseMotionMetaData) {
  var availableTrials = purchaseMotionMetaData.availableTrials,
      customerCurrencyCode = purchaseMotionMetaData.customerCurrencyCode,
      productCatalog = purchaseMotionMetaData.productCatalog,
      productBasedOffers = purchaseMotionMetaData.productBasedOffers,
      parcels = purchaseMotionMetaData.parcels,
      subscriptionTerms = purchaseMotionMetaData.subscriptionTerms;


  return {
    authState: _AuthStates.AUTHED,
    availableTrials: (0, _availableTrialsAdapter2.default)(availableTrials),
    customerCurrencyCode: customerCurrencyCode,
    productCatalog: (0, _productsAdapter2.default)({ productCatalog: productCatalog, customerCurrencyCode: customerCurrencyCode }).products,
    productBasedOffers: productBasedOffers,
    parcels: parcels,
    subscriptionTerms: subscriptionTerms
  };
};

var getPurchaseMotionData = exports.getPurchaseMotionData = function getPurchaseMotionData() {
  var merchandiseIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  merchandiseIds.forEach(_validators.validateMerchandiseId);

  return (0, _purchaseMotionApi.fetchPurchaseMotionData)(merchandiseIds).then(function (purchaseMotionData) {
    return _extends({}, _adaptPurchaseMotionResponse(purchaseMotionData), {
      purchaseMotions: purchaseMotionData.purchaseMotions
    });
  });
};

var getLocationAwarePurchaseMotionData = exports.getLocationAwarePurchaseMotionData = function getLocationAwarePurchaseMotionData(_ref) {
  var merchandiseIds = _ref.merchandiseIds,
      locations = _ref.locations,
      apiGetter = _ref.apiGetter;

  if (!locations || locations.length === 0) {
    throw new Error('Need to specify location');
  }

  if (!merchandiseIds) {
    merchandiseIds = [];
  }

  merchandiseIds.forEach(_validators.validateMerchandiseId);

  return (0, _purchaseMotionApi.fetchLocationAwarePurchaseMotionData)({
    merchandiseIds: merchandiseIds,
    locations: locations,
    apiGetter: apiGetter
  }).then(function (response) {
    return _extends({}, response, {
      metadata: _adaptPurchaseMotionResponse(response.metadata)
    });
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/api/getPurchaseMotionData.js
// module id = 346
// module chunks = 3 4 5